import {useEffect} from 'react'
import {useIntl} from 'react-intl'
import {useMutation, useQuery} from 'react-query'
import {toast} from 'react-toastify'
import FormDepartment from '../form'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {getBreadCrumbs} from '../breadcrumbs'
import {
  getDepartmentById,
  postDepartment,
  putDepartment,
} from '../../../../modules/services/department.service'
import {useNavigate, useParams} from 'react-router'

const ConfigurationPageDepartment = () => {
  const navigate = useNavigate()
  const {id} = useParams<{id: string}>()
  useEffect(() => {
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])
  const {data, isLoading} = useQuery(['getDepartment', id], async () => await getDepartmentById(id))
  const initValue = {
    name: data?.attributes.name,
    annual_budget: data?.attributes.annual_budget,
    kpi_redemption: data?.attributes.kpi_redemption,
    spending: data?.attributes.spending,
    point_conversation: data?.attributes.point_conversation,
    description: data?.attributes.description,
  }

  const handleChange = (form: any) => {
    mutate(form)
  }
  const {mutate} = useMutation(putDepartment, {
    onSuccess: async () => {
      toast.success('Update Data Success')
      navigate('/configuration/department')
    },
    onError(error: any, variables, context) {
      console.log('Error', error.response?.data)
      toast.error(error.response?.data?.error?.message)
    },
  })

  return (
    <>
      <div className='card mb-10'>
        <div className='card-body d-flex justify-content-between align-items-center py-8'>
          <div className='ms-6'>
            <p className='fw-bold fs-6 p-0 m-0'>Update Department</p>
          </div>
        </div>
        <FormDepartment
          initLoad={initValue}
          handleChange={handleChange}
          loadings={isLoading}
          id={id}
        />
      </div>
    </>
  )
}

const DepartmentWrapperUpdate = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={getBreadCrumbs('/configuration/department')}>
        {intl.formatMessage({id: 'MENU.CONFIGURATION.DEPARTMENT'})}
      </PageTitle>
      <ConfigurationPageDepartment />
    </>
  )
}

export default DepartmentWrapperUpdate
